<template>
  <b-modal
    ref="documentosPropostaModal"
    size="xl"
    hide-footer
    no-close-on-backdrop
    scrollable
    :dialog-class="'alteracao-tamanho-pre-geracao'"
    :modal-class="'center-modal'"
    title="Documentos da Proposta"
    title-class="titulo-modal"
    @show="show"
    @hide="close"
  >
    <div
      class="h-100 d-flex flex-column"
      style="min-height: 60vh;"
    >
      <b-table
        :items="linhasDocumentos"
        :fields="camposTabela"
        responsive
        bordered
        small
        class="mb-2 flex-grow-1"
        show-empty
        empty-text="Nenhum documento adicionado."
        head-variant="light"
        style="min-height: 0;"
      >
        <template #cell(documento)="{ item, index }">
          <div
            class="d-grid"
            style="grid-template-columns: 1fr auto; align-items: center; width: 100%;"
          >
            <documento-select
              :disabled="item.id !== undefined && item.id !== null"
              :value="item.documento"
              :multiple="false"
              :apenas-ativos="true"
              class="w-100"
              @input="onSelecionarDocumento($event, index)"
            />
            <span
              v-if="item.documento && item.cobranca && item.cobranca.status !== undefined"
              :class="[getStatusClass(item.cobranca.status), 'text-nowrap', 'm-2']"
              :title="getStatusLabel(item.cobranca.status)"
            >
              <small>{{ getStatusLabel(item.cobranca.status) }}</small>
            </span>
          </div>
        </template>
        <template #cell(acoes)="{ item, index }">
          <b-button
            :id="`remover-documento-${index}`"
            :disabled="!habilitarDeletar(item)"
            variant="danger"
            size="sm"
            class="mr-1"
            @click="removerLinha(index)"
          >
            <feather-icon icon="TrashIcon" />
            <b-tooltip
              triggers="hover"
              :target="`remover-documento-${index}`"
              title="Remover documento"
              :delay="{ show: 500, hide: 50 }"
            />
          </b-button>

          <b-dropdown
            :id="`acoes-documento-dropdown-${index}`"
            text="Ações"
            variant="primary"
            size="sm"
            class="mr-1 d-inline-block"
            menu-class="p-0"
            :disabled="!habilitarVisualizarDoc(item) && !habilitarAprovarDocumento(item) && !habilitarRecusarDocumento(item)"
          >
            <b-dropdown-item
              :disabled="!habilitarVisualizarDoc(item)"
              @click="visualizarDocumento(item)"
            >
              <feather-icon
                icon="ExternalLinkIcon"
                class="mr-1"
              /> Visualizar documento
            </b-dropdown-item>
            <b-dropdown-item
              :disabled="!habilitarAprovarDocumento(item)"
              @click="aprovarDocumento(item)"
            >
              <feather-icon
                icon="CheckCircleIcon"
                class="mr-1"
              /> Aprovar documento
            </b-dropdown-item>
            <b-dropdown-item
              :disabled="!habilitarRecusarDocumento(item)"
              @click="abrirModalJustificativa(item)"
            >
              <feather-icon
                icon="XCircleIcon"
                class="mr-1"
              /> Recusar documento
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="primary"
          size="sm"
          class="mr-1"
          @click="adicionarLinha"
        >
          Adicionar Documento
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="mr-1"
          :disabled="!proposta.statusProposta || (proposta.statusProposta !== 'aprovada' && proposta.statusProposta !== 'finalizada')"
          @click="cobrarManualmente"
        >
          Cobrar Manualmente
        </b-button>
        <b-button
          variant="success"
          size="sm"
          :disabled="!podeSalvar"
          @click="salvarDocumentos"
        >Salvar</b-button>
      </div>
    </div>
    <visualizar-arquivo
      v-if="mostrarVisualizacaoArquivo"
      :url="urlVisualizacaoArquivo"
      @hidden="fecharVisualizarArquivo()"
    />
    <!-- Modal de justificativa -->
    <modal-justificativa
      id="'modalJustificativa'"
      :ref="'modalJustificativa'"
      :texto-apresentacao="'Informe o motivo da recusa'"
      @cancelar="fecharModalJustificativa()"
      @confirmar="recusarDocumento($event)"
    />
  </b-modal>
</template>

<script>
import {
  BModal, BTable, BTooltip, BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'DocumentosPropostaModal',
  components: {
    BModal,
    BTable,
    BTooltip,
    BButton,
    DocumentoSelect: () => import('@/shared/components/documento-select/DocumentoSelect.vue'),
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
    ModalJustificativa: () => import('@/shared/components/modal-justificativa/ModalJustificativa.vue'),
  },
  props: {
    proposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarVisualizacaoArquivo: false,
      documentoSelecionado: null,
      linhasDocumentos: [], // cada linha: { documentoId, documento }
      documentosOriginais: [], // formato original recebido
      urlVisualizacaoArquivo: '',
      camposTabela: [
        {
          key: 'documento',
          label: 'Documento',
        },
        {
          key: 'acoes',
          label: 'Ações',
          class: 'text-center',
          thStyle: { width: '200px' },
        },
      ],
    }
  },

  computed: {
    podeSalvar() {
      // Habilita o botão se houver pelo menos um documento novo (sem id)
      return this.linhasDocumentos.some(linha => !linha.id && linha.documento)
    },
  },
  // Não precisa mais do watch de proposta
  created() {
    // Garante que o listener é registrado assim que o componente é criado
    this.$root.$on('proposta-salva', this.onPropostaSalva)
  },
  beforeDestroy() {
    // Remove o listener para evitar múltiplos listeners ou vazamentos
    this.$root.$off('proposta-salva', this.onPropostaSalva)
  },
  methods: {
    async show() {
      await this.fetchDocumentosProposta()
      this.$refs.documentosPropostaModal.show()
    },
    close() {
      this.$refs.documentosPropostaModal.hide()
    },
    adicionarLinha() {
      this.linhasDocumentos.push({ documentoId: null, documento: null })
    },
    removerLinha(index) {
      const linha = this.linhasDocumentos[index]
      // Se a linha tem id, deleta no backend, senão só remove da tabela
      if (linha && linha.id) {
        this.$confirmar('Tem certeza que deseja excluir este documento?', 'Está ação não pode ser desfeita. Caso o usuario já tenha realizado o upload do documento, o mesmo será excluído permanentemente.', 'question', 'danger')
          .then(async result => {
            if (result.value) {
              try {
                await api.deletaDocumentoProposta(this.proposta.id, linha.id)
                await this.fetchDocumentosProposta()
              } catch (error) {
                this.notificarErro('Erro ao deletar documento.')
              }
            }
          })
          .catch(error => {
            this.notificarErro(`Erro ao deletar documento. ${error.response?.message}`)
          })
      } else {
        this.linhasDocumentos.splice(index, 1)
      }
    },
    onSelecionarDocumento(doc, index) {
      this.$set(this.linhasDocumentos, index, { documentoId: doc ? doc.id : null, documento: doc })
    },
    habilitarVisualizarDoc(doc) {
      return doc && doc.id
        && this.proposta.statusProposta === 'aprovada'
        && doc.cobranca?.publicado === true
        && doc.cobranca?.nomeArq
    },
    habilitarDeletar(doc) {
      return doc != null
    },
    async visualizarDocumento(doc) {
      this.documentoSelecionado = doc
      this.urlVisualizacaoArquivo = ''
      if (doc && doc.cobranca?.id) {
        try {
          const result = await api.getArquivoDocumento(doc.cobranca.id)
          this.urlVisualizacaoArquivo = (result && result.data && result.data.url) ? result.data.url : ''
          if (!this.urlVisualizacaoArquivo) {
            this.notificarErro('URL do documento não encontrada.')
            return
          }
        } catch (e) {
          this.notificarErro('Erro ao obter a URL do documento.')
          return
        }
      }
      this.mostrarVisualizacaoArquivo = true
    },
    async onPropostaSalva(proposta) {
      // Só busca se a proposta atual for a mesma
      if (!proposta || !proposta.id) return
      await this.fetchDocumentosProposta()
    },

    async fetchDocumentosProposta() {
      // Busca documentos da proposta no backend
      if (!this.proposta || !this.proposta.id) return
      try {
        const resp = await api.getDocumentosProposta(this.proposta.id)
        const docs = Array.isArray(resp.data) ? resp.data : []
        this.documentosOriginais = [...docs]
        this.linhasDocumentos = docs
      } catch (e) {
        // Pode exibir erro se quiser
        // this.$erro('Erro ao buscar documentos da proposta')
      }
    },
    async salvarDocumentos() {
      // Remove linhas sem documento selecionado
      const docsSelecionados = this.linhasDocumentos.filter(linha => linha.documento)
      let documentosEnviar = []
      if (this.documentosOriginais.length) {
        documentosEnviar = docsSelecionados.map(linha => {
          const original = this.documentosOriginais.find(orig => orig.documento && orig.documento.id === linha.documento.id)
          if (original) {
            return original
          }
          return { documentoId: linha.documento.id, documento: linha.documento }
        })
      } else {
        documentosEnviar = docsSelecionados.map(linha => ({ documentoId: linha.documento.id, documento: linha.documento }))
      }
      try {
        await api.salvarDocumentosProposta(this.proposta.id, documentosEnviar)
        this.close()
      } catch (e) {
        // Pode exibir erro se quiser
        // this.$erro('Erro ao salvar documentos da proposta')
      }
    },
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    },
    notificarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'SuccessCircleIcon',
          variant: 'success',
        },
      })
    },
    habilitarRecusarDocumento(item) {
      // Só habilita se status for "Aguardando homologação" (1)
      return item.documento && item.cobranca && item.cobranca.status === 1
    },
    async recusarDocumento(justificativa) {
      if (!this.documentoSelecionado || !this.documentoSelecionado.documento || !this.documentoSelecionado.cobranca) return

      this.$confirmar('Tem certeza que deseja recusar este documento?', '', 'question', 'danger')
        .then(async result => {
          if (result.value) {
            try {
              await api.atualizaDocumentoCobrancaStatus(this.documentoSelecionado.cobranca.id, 4, justificativa)
              this.notificarSucesso('Documento recusado com sucesso!')
              this.fetchDocumentosProposta()
              this.fecharModalJustificativa()
            } catch (e) {
              this.notificarErro('Erro ao recusar documento da proposta')
            }
          }
        })
        .catch(error => {
          this.notificarErro(`Erro ao recusar documento da proposta. ${error?.response?.data?.message}`)
        })
    },
    async aprovarDocumento(doc) {
      if (!doc || !doc.id) return
      this.$confirmar('Tem certeza que deseja aprovar este documento?', '', 'question', 'danger')
        .then(async result => {
          if (result.value) {
            try {
              await api.atualizaDocumentoCobrancaStatus(doc.cobranca.id, 3, 'Aprovado')
              this.$emit('documento-aprovado', doc)
              this.fetchDocumentosProposta()
            } catch (error) {
              this.notificarErro(`Erro ao aprovar documento da proposta: ${error.message}`)
            }
          }
        })
        .catch(error => {
          this.notificarErro(`Erro ao aprovar documento da proposta: ${error.message}`)
        })
    },
    getStatusLabel(status) {
      const map = {
        0: 'Nenhum',
        1: 'Aguardando homologação',
        2: 'Pendente',
        3: 'Homologado',
        4: 'Recusado',
        5: 'Cancelado',
        6: 'Dispensado',
      }
      return map[status] || 'Desconhecido'
    },
    getStatusClass(status) {
      switch (status) {
        case 1: return 'text-warning' // Aguardando homologação
        case 2: return 'text-secondary' // Pendente
        case 3: return 'text-success' // Homologado
        case 4: return 'text-danger' // Recusado
        case 5: return 'text-muted' // Cancelado
        case 6: return 'text-info' // Dispensado
        default: return 'text-body'
      }
    },
    habilitarAprovarDocumento(item) {
      // Só habilita se status for "Aguardando homologação" (1)
      return item.documento && item.cobranca && item.cobranca.status === 1
    },
    fecharVisualizarArquivo() {
      this.mostrarVisualizacaoArquivo = false
      this.documentoSelecionado = null
      this.urlVisualizacaoArquivo = ''
    },
    fecharModalJustificativa() {
      this.documentoSelecionado = null
      this.$refs.modalJustificativa.hide()
    },
    abrirModalJustificativa(item) {
      this.documentoSelecionado = item
      this.$refs.modalJustificativa.show()
    },
    cobrarManualmente() {
      // Busca o primeiro documento com a propriedade cobranca e "última cobrança"
      const docComUltimaCobranca = this.documentosOriginais.find(
        doc => doc.cobranca
        && (doc.cobranca.status === 4 || doc.cobranca.status === 2)
        && doc.cobranca['última cobrança'],
      )
      const mensagemConfirma = docComUltimaCobranca
        ? `Última cobrança realizada em ${new Date(docComUltimaCobranca.cobranca['última cobrança']).toLocaleString('pt-BR')}`
        : ''

      this.$confirmar('Cobrar documentos manualmente ?', mensagemConfirma, 'question', 'danger')
        .then(result => {
          if (result.value) {
            api.cobrarDocumentosProposta(this.proposta.id)
              .then(() => {
                this.notificarSucesso('Cobrança realizada com sucesso!')
                this.fetchDocumentosProposta()
              })
              .catch(response => {
                const mensagemErro = response?.response?.data?.message || 'Erro ao realizar cobrança dos documentos.'
                this.notificarErro(mensagemErro)
              })
          }
        })
    },
  },
}
</script>
